import { api } from '@/lib/axios';
import { Process, ProcessTask } from './processes.service';

export interface TaskExecution {
  id: string;
  executionId: string;
  taskId: string;
  status: 'pending' | 'completed';
  photoUrl?: string;
  executedAt?: string;
  notes?: string;
  task: ProcessTask;
}

export interface ProcessExecution {
  id: string;
  processId: string;
  userId: string;
  status: 'in_progress' | 'completed';
  startedAt: string;
  completedAt?: string;
  notes?: string;
  process: Process;
  tasks: TaskExecution[];
  user?: {
    id: string;
    name: string;
    email: string;
    client?: {
      id: string;
      name: string;
    };
  };
}

export interface StartExecutionDto {
  processId: string;
  notes?: string;
}

export interface CompleteTaskDto {
  description?: string;
  timeSpent?: number;
  photoUrl?: string;
  notes?: string;
}

export interface CompleteExecutionDto {
  notes?: string;
}

class ExecutionsService {
  async startExecution(data: StartExecutionDto): Promise<ProcessExecution> {
    const { data: execution } = await api.post('/executions/start', data);
    return execution;
  }

  async getMyExecutions(status?: string): Promise<ProcessExecution[]> {
    const { data } = await api.get('/executions/my', { params: { status } });
    return data;
  }

  async getExecution(id: string): Promise<ProcessExecution> {
    const { data } = await api.get(`/executions/${id}`);
    return data;
  }

  async completeTask(
    executionId: string,
    taskId: string,
    data: CompleteTaskDto,
  ): Promise<TaskExecution> {
    const { data: result } = await api.patch(
      `/executions/${executionId}/tasks/${taskId}/complete`,
      data,
    );
    return result;
  }

  async completeExecution(
    executionId: string,
    data: CompleteExecutionDto,
  ): Promise<ProcessExecution> {
    const { data: result } = await api.patch(
      `/executions/${executionId}/complete`,
      data,
    );
    return result;
  }

  async getTodayExecutions(date?: string): Promise<ProcessExecution[]> {
    const { data } = await api.get('/executions/today', { params: { date } });
    return data;
  }
}

export const executionsService = new ExecutionsService();
